import { UserPermissions } from "core/types/enums/PermissionsEnum";
import { hostToolLinks, technichianToolLinks } from "constants/AppLinks";
import { WORK_ORDER_VIEW_PERMISSIONS } from "constants/permissions";

const navbarMenuItems = [
  {
    type: "link",
    title: "Start Office timer",
    link: "timer",
    permissions: [UserPermissions["Payroll.Upsert"]],
    isMobile: true,
  },
  {
    type: "link",
    title: "Tenants",
    link: `/host/${hostToolLinks.tenants}`,
    permissions: [UserPermissions.GlobalAdmin],
  },
  {
    type: "link",
    title: "Admins",
    link: `/host/${hostToolLinks.admins}`,
    permissions: [UserPermissions.GlobalAdmin],
  },
  {
    type: "link",
    title: "Features",
    link: `/host/${hostToolLinks.features}`,
    permissions: [UserPermissions.GlobalAdmin],
  },
  {
    type: "link",
    title: "Estimate",
    link: `/${technichianToolLinks.estimatesNew}`,
    permissions: [
      UserPermissions["Estimate.Upsert"],
      UserPermissions["Item.View"],
      UserPermissions["Company.View"],
    ],
    isStrict: true,
  },
  {
    type: "link",
    title: "Supplies",
    link: `/${technichianToolLinks.items}`,
    permissions: [UserPermissions["Item.View"], UserPermissions["Vendor.View"]],
    isStrict: false,
  },
  {
    type: "link",
    title: "Payroll",
    link: `/${technichianToolLinks.payroll}`,
    permissions: [],
    isNonGlobalAdmin: true,
  },
  {
    type: "link",
    title: "Sales",
    link: `/${technichianToolLinks.companySales}`,
    permissions: [
      UserPermissions["Estimate.View"],
      UserPermissions["Company.View"],
      UserPermissions["Item.View"],
    ],
  },
  {
    type: "link",
    title: "Schedule",
    link: `/${technichianToolLinks.schedule}`,
    permissions: [UserPermissions["Calendar.View"]],
  },
  {
    type: "link",
    title: "My Work",
    link: `/${technichianToolLinks.workOrdersList}`,
    permissions: WORK_ORDER_VIEW_PERMISSIONS,
  },
  {
    type: "link",
    title: "Customers",
    link: `/${technichianToolLinks.companyList}`,
    permissions: [UserPermissions["Company.View"]],
  },
  {
    visible: false,
    type: "dropdown",
    title: "Manage Entities",
    dropdownItems: [
      {
        title: "Equipment Makes",
        link: `/${technichianToolLinks.equipmentMakesList}`,
        permissions: [UserPermissions["Equipment.View"]],
      },
      {
        title: "Equipment Models",
        link: `/${technichianToolLinks.equipmentModelsList}`,
        permissions: [UserPermissions["Equipment.View"]],
      },
      {
        title: "Equipment Types",
        link: `/${technichianToolLinks.equipmentTypesList}`,
        permissions: [UserPermissions["Equipment.View"]],
      },
      {
        title: "Vehicles",
        link: `/${technichianToolLinks.vehiclesList}`,
        permissions: [UserPermissions["Vehicle.View"]],
      },
    ],
    permissions: [UserPermissions["Equipment.View"]],
  },
];

export const navbarMenuItemsAdmin = {
  type: "dropdown",
  title: "Manage Entities",
  dropdownItems: [
    {
      title: "Equipment Makes",
      link: `/${technichianToolLinks.equipmentMakesList}`,
      permissions: [UserPermissions["Equipment.View"]],
    },
    {
      title: "Equipment Models",
      link: `/${technichianToolLinks.equipmentModelsList}`,
      permissions: [UserPermissions["Equipment.View"]],
    },
    {
      title: "Equipment Types",
      link: `/${technichianToolLinks.equipmentTypesList}`,
      permissions: [UserPermissions["Equipment.View"]],
    },
    {
      title: "Vehicles",
      link: `/${technichianToolLinks.vehiclesList}`,
      permissions: [UserPermissions["Vehicle.View"]],
    },
  ],
  permissions: [UserPermissions["Equipment.View"]],
};

export default navbarMenuItems;
